'use client'
import Image from 'next/image'
import Link from 'next/link'
import { usePathname } from 'next/navigation'

const adHorizBelow = 'https://media.travelm.de/travelm-bucket/Erlebe_Advertisement%202.webp'

const TravelSectionAdHorizBelowAd2 = ({ title }) => {
  const pathname = usePathname()
  if (pathname.includes('trending-article')) {
    return null
  }

  return (
    <div className="ad__row">
      <Link
        href="/de-DE/trending-article/besondere-erlebnisse-und-echte-begegnungen"
        target="_blank"
        rel="noopener noreferrer"
      >
        <Image src={adHorizBelow} alt={title} width={1600} height={400} />
        <p className="ad__text">{title}</p>
      </Link>
    </div>
  )
}

export default TravelSectionAdHorizBelowAd2
